// extracted by mini-css-extract-plugin
export default {"upload":"index_upload__X0BSw"};